import { useState } from "react";
import { PAY_METHODS, today } from "@/lib/format";

export default function PaymentForm({ initial, families, onSave, onCancel }) {
  const [p, setP] = useState(() => ({ family_id: "", payer_name: "", amount: "", method: "Cash", date: today(), note: "", ...(initial || {}) }));
  const set = (k) => (e) => setP({ ...p, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    onSave({ ...p, family_id: p.family_id || null, amount: Number(p.amount) });
  };
  return (
    <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3" data-testid="payment-form">
      {families && (
        <select data-testid="payment-family-select" className="field sm:col-span-2" value={p.family_id || ""} onChange={set("family_id")}>
          <option value="">Not registered yet — link later</option>
          {families.map((f) => <option key={f.id} value={f.id}>{f.family_name}</option>)}
        </select>
      )}
      {families && !p.family_id && (
        <input required data-testid="payment-payer-input" className="field sm:col-span-2" placeholder="Who paid? (name or household)" value={p.payer_name || ""} onChange={set("payer_name")} />
      )}
      <input required data-testid="payment-amount-input" className="field" inputMode="decimal" placeholder="Amount $" value={p.amount} onChange={set("amount")} />
      <select data-testid="payment-method-select" className="field" value={p.method} onChange={set("method")}>{PAY_METHODS.map((m) => <option key={m}>{m}</option>)}</select>
      <input data-testid="payment-date-input" type="date" className="field" value={p.date} onChange={set("date")} />
      <input data-testid="payment-note-input" className="field" placeholder="Note (check #, who paid…)" value={p.note} onChange={set("note")} />
      <div className="sm:col-span-2 flex gap-3">
        <button data-testid="payment-save-button" className="btn-secondary">Save payment</button>
        {onCancel && <button type="button" data-testid="payment-cancel-button" onClick={onCancel} className="btn-outline">Cancel</button>}
      </div>
    </form>
  );
}
